module.exports = __webpack_public_path__ + "static/media/about.d14173bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/about.jpg
// module id = 500
// module chunks = 0